export default {
  apiKey: 'AIzaSyCBKZjjs4oie1EHA4pznMJGIfd3nnLSPpk',
  authDomain: 'quizland-4c0f1.firebaseapp.com',
  databaseURL: 'https://quizland-4c0f1.firebaseio.com',
  projectId: 'quizland-4c0f1',
  storageBucket: 'quizland-4c0f1.appspot.com',
  messagingSenderId: '2215219162'
}
